// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__imr-4","modalForm":"UpgradeEpcsModal_modalForm__5P-fj","modalFooter":"UpgradeEpcsModal_modalFooter__cW5fp"};